import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { HexColorPicker } from "react-colorful";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

import { userRoleEnum, roleExpEnum } from "../../../config/enum";

import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";
import { setAllUsers } from "redux/reducers/usersReducer";

export default function UserRole({ role, setRole, superior, setSuperior, color, setColor }) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }

  const [roleExp, setRoleExp] = useState("");

  useEffect(() => {
    setRoleExp(roleExpEnum[role]);
  }, [role]);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={role === "Technicien" ? "6" : "12"}>
            <Autocomplete
              options={userRoleEnum}
              value={role}
              onChange={(event, newRole) => {
                setRole(newRole);
                // Reset color if changing from Contremaître to another role
                if (newRole !== "Contremaître" && role === "Contremaître") {
                  setColor("#000000");
                }
              }}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  label="Choisissez le rôle de l'utilisateur"
                  variant="standard"
                />
              )}
            />
          </Grid>
          {role === "Technicien" && (
            <Grid item xs={6}>
              <Autocomplete
                options={allUsers}
                value={superior}
                onChange={(event, newSuperior) => {
                  setSuperior(newSuperior);
                }}
                renderInput={(params) => (
                  <MDInput
                    {...params}
                    label="Déterminez le supérieur hiérarchique"
                    variant="standard"
                  />
                )}
              />
            </Grid>
          )}
        </Grid>
        
        {role === "Contremaître" && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <MDTypography variant="h6" gutterBottom>
                Couleur du contremaître
              </MDTypography>
              <MDBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" }
                }}
              >
                <HexColorPicker
                  color={color}
                  onChange={setColor}
                  style={{ width: "200px", height: "200px" }}
                />
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexDirection: "column"
                  }}
                >
                  <MDBox
                    sx={{
                      width: 80,
                      height: 80,
                      backgroundColor: color,
                      border: "1px solid #ccc",
                      borderRadius: "4px"
                    }}
                  />
                  <TextField
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    label="Code couleur"
                    variant="standard"
                    size="small"
                    sx={{ width: "120px" }}
                  />
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox mt={2}>
        <MDTypography textAlign="center" variant="body1">
          {roleExp}
        </MDTypography>
      </MDBox>
    </>
  );
}